import type { PropertyValue, Schema } from "src/api/flowTypes";
import { SchemaOptions } from "src/router/SearchParams";
import type { PropertyUI, SchemaUI } from "src/schema/schemaMappingUtils";
import { SchemaConverter } from "src/schema/schemaMappingUtils";

// Agent-specific property UI with description
export type AgentSchemaPropertyUI = PropertyUI & {
  description?: string;
};

// Agent-specific schema UI
export type AgentSchemaUI = SchemaUI & {
  properties: AgentSchemaPropertyUI[];
};

// Backend schema with description
export type AgentSchemaBE = Schema & {
  properties: Record<string, PropertyValue & { description?: string }>;
};

// Convert backend JSON schema to UI-friendly format
export const convertAgentSchemaBEtoUI = (
  schemaBE: AgentSchemaBE | Schema | null | undefined,
): AgentSchemaUI | null => {
  if (!schemaBE || !schemaBE.properties) return null;

  // Use the shared SchemaConverter for the heavy lifting
  const schemaUI = SchemaConverter.beToUI(
    schemaBE as Schema,
    SchemaOptions.Output,
  );

  // Add agent-specific fields (description)
  return {
    ...schemaUI,
    properties: schemaUI.properties.map((property) => ({
      ...property,
      description:
        (
          schemaBE.properties as Record<
            string,
            PropertyValue & { description?: string }
          >
        )[property.fieldName]?.description ?? "",
    })),
  };
};
